import React, { useEffect, useState } from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';

const ADD_SUBWORKFLOW_WIDTH = '800px';

const ErrorDialog = ({ errors, onClose }) => {
  const [modalContent, setModalContent] = useState([]);

  useEffect(() => {
    if (!errors) {
      return;
    }
    const content = [];
    errors.forEach((errorList, key) => {
      content.push(
        <div key={key}>
          <Heading level={4}>{key}</Heading>
          <Text tag="ul">
            {errorList.map(error => (
              <li>{error}</li>
            ))}
          </Text>
        </div>
      );
    });
    setModalContent(content);
  }, [errors]);
  return errors ? (
    <Modal
      title="Unable to Save"
      open={errors && errors.size > 0}
      scrollContainer="modal"
      closeLabel="Close"
      width={ADD_SUBWORKFLOW_WIDTH}
    >
      <div className="minh-300">{modalContent}</div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="primary" size="small" onClick={onClose}>
            Close
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  ) : null;
};

export default ErrorDialog;
